/** Shared UI components: rows, dialogs, fields and small controls. */
export default {
  statusQuestion: "Needs your attention",
  statusError: "Error",
  statusUnread: "Unread",
  statusWorking: "Working",
  backPrefix: "Back,",
  confirm: "Confirm",
  saving: "Saving…",
  saveChangeFailed: "Couldn’t save this change. Please try again.",
  sectionFailed: "Something went wrong rendering this section.",
  editText: "Edit text",
  clickToEdit: "Click to edit",
  closePreview: "Close preview",
  syncImage: "Sync image",
  syncingImage: "Syncing image…",
  imageSynced: "Image synced",
  syncImageFailed: "Could not sync this image.",
  fullSizeImage: "Full size image",
  agentAvatar: "Agent avatar",
  showPassword: "Show password",
  hidePassword: "Hide password",
  pickColor: "Pick color",
  colorSwatch: "Color {color}",
  loading: "Loading",
  contextUsed: "{percent}% context used",
} as const;
